import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { getInRibbonMode } from 'owa-command-ribbon-store';
import { LazyMailRibbon } from 'owa-mail-ribbon';
import MailCommandToolbar from './MailCommandToolbar';

export default observer(function MailCommandBarView() {
    if (getInRibbonMode()) {
        return <LazyMailRibbon />;
    }

    return <MailCommandToolbar />;
});
